/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */

/**
 * 取込対象とするファイルカテゴリ。
 */
export type ImportRuleFileCategory = typeof ImportRuleFileCategory[keyof typeof ImportRuleFileCategory];


export const ImportRuleFileCategory = {
  image: 'image',
  video: 'video',
  csv: 'csv',
} as const;
